import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function clienteSirena(args) {
  const response = await axios.get(`${REACT_APP_API}/sirena/client/${args}`)
  return response
}